  <template>
    <div class="rootPnp">
      <input type="hidden" name="_token" :value="csrf" />
      <input v-if="this.editing" type="hidden" name="_method" value="PUT" />

      <div class="row px-3">
        <div class="col-lg-6 col-md-6 col-12 card p-2 border-card shadow" v-if="factors_indicators.length < 1">
          <label>
            <i class="fas fa-solid fa-exclamation-triangle" style="color:red"></i>
            {{ __("forms.BaseChartsFactors.missingFactors") }}
          </label>
        </div>
        <div class="col-lg-6 col-md-6 col-12 card p-2 border-card shadow" v-if="values.length < 1">
          <label>
            <i class="fas fa-solid fa-exclamation-triangle" style="color:red"></i>
            {{ __("forms.BaseChartsIndicators.missingIndicators") }}
          </label>
        </div>
      </div>
      <!-- FACTORS TABLE -->
      <div class="table--custom">
        <!-- CASE NO COLUMN FACTORS -->
        <div class="single--row single--row-head py-2" style="height:100%"
          v-if="!show_arithmetic_mean && !show_weights && !show_arithmetic_weights_mean">
          <div class="row">
            <div class="col-12">
              <div class="single--row-info">
                {{ __('forms.EvaluationChart.questions.questions_setting.question8.factorsLabel') }}
              </div>
            </div>
          </div>
        </div>
        <!-- CASE STANDARD -->
        <div v-else class="single--row single--row-head">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-12">

              <div class="single--row-info">
                {{ __('forms.EvaluationChart.questions.questions_setting.question8.factorsLabel') }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_mean">
              <div class="single--row-info">
                <div class="single--row-info-group">
                  {{ __('forms.EvaluationChart.questions.questions_setting.question8.evaluation') }}
                </div>
                <div class="single--row-columns">
                  <div class="single--row-column fontMin w-100" v-for="(column, indexC) in columns" :key="indexC">
                    {{ column }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-1 col-md-1 col-12" v-if="show_weights">
              <div class="single--row-info">
                {{ __('forms.EvaluationChart.questions.questions_setting.question8.weight') }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_weights_mean">
              <div class="single--row-info">
                <div class="single--row-info-group">
                  {{ __('forms.EvaluationChart.questions.questions_setting.question8.weighted_evaluation') }}
                </div>
                <div class="single--row-columns">
                  <div class="single--row-column fontMin w-100" v-for="(column, indexC) in columns" :key="indexC">
                    {{ column }} {{ __('forms.EvaluationChart.questions.questions_setting.question8.weighted') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FACTOR ROWS -->
        <div class="single--row single--row-content" v-for="(factor, indexF) in factors_indicators" :key="indexF">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-12">
              <div class="single--row-info">
                {{ factor.name }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_mean">
              <div class="single--row-info">
                <div class="single--row-columns single--row-columns-full-height">
                  <div class="single--row-column w-100" v-for="(column, indexC) in columns" :key="indexC">
                    <span v-if="!empty_values">
                      {{ factorsTable[indexF]["avg_arithm"][indexC] }}
                    </span>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-1 col-md-1 col-12" v-if="show_weights">
              <div class="single--row-info">
                {{ factor.weight / 100 }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_weights_mean">
              <div class="single--row-info">
                <div class="single--row-columns single--row-columns-full-height">
                  <div class="single--row-column w-100" v-for="(column, indexC) in columns" :key="indexC">
                    <span v-if="show_arithmetic_weights_mean">
                      {{ factorsTable[indexF]["avg_weight"][indexC] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show_arithmetic_mean || show_arithmetic_weights_mean" class="single--row single--row-total">
          <div class="row" style="background-color: #559bd9;">
            <div class="col-lg-7 col-md-7 col-12">
              <div class="single--row-info">
                <div class="single--row-columns single--row-columns-full-height">
                  <div class="single--row-column w-100 font-weight-bold" style='color: white !important;'>
                    {{ __('misc.results') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_mean">
              <div class="single--row-info">
                <div class="single--row-columns single--row-columns-full-height">
                  <div class="single--row-column w-100 font-weight-bold" v-for="(column, indexC) in columns"
                    :key="indexC" style='color: white !important;'>
                    <span v-if="show_arithmetic_mean && !empty_values">
                      {{ summary["zero_weight_" + indexC] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-1 col-md-1 col-12" v-if="show_weights">
              <div class="single--row-info font-weight-bold">
                <span style='color: white !important;'>{{ summary.weight }}</span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12" v-if="show_arithmetic_weights_mean">
              <div class="single--row-info">
                <div class="single--row-columns single--row-columns-full-height">
                  <div class="single--row-column w-100 font-weight-bold" v-for="(column, indexC) in columns"
                    :key="indexC">
                    <span v-if="!empty_values" style='color: white !important;'>
                      {{ summary[indexC].toFixed(2) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group ml-2" v-if="(graphs.bars || graphs.radar) && !empty_values">
        <button type="button" id="pnpShowGraph" class="btn btn--blue mt-3" @click="onUpdateFactors()">
          {{ __("misc.update") }} {{ __("misc.graph") }}
        </button>
      </div>
      <!-- Grafici -->
      <div class="form-group">
        <div class="row" v-if="!empty_values">
          <div v-if="graphs.bars" class="col-12 col-lg-7">
            <horizontal-bar-pnp ref="horizontal_bar_pnp" :range="range_value"></horizontal-bar-pnp>
          </div>
          <div v-if="graphs.radar && show_weights" class="col-12 col-lg-5">
            <radar-pnp ref="radar_pnp" :range="range_value"></radar-pnp>
          </div>
        </div>
      </div>

      <!-- Indicators -->
      <div class="row px-4 my-3 mt-3">
        <div class="col-12">
          <button class="btn btn--blue" @click="hideAll" type="button">
            {{ __("views.pnpQuestion.hideAll") }}
          </button>
          <button class="btn btn--blue" @click="showAll" type="button">
            {{ __("views.pnpQuestion.openAll") }}
          </button>
        </div>
      </div>
      <div class="mb-2 px-4" v-for="(factor, indexF) in factors_indicators" :key="indexF"
        style="page-break-before: always">

        <button class="btn w-100 justify-content-between mb-2" type="button" @click="toggle(indexF)">
          {{ factor.name }}
          <i :ref="'chevron' + indexF" class="fas fa-chevron-up"></i>
        </button>
        <div class="" :ref="'collapse' + indexF">
          <div class="table--custom w-100 mx-0" style="">
            <div class="single--row single--row-head">
              <div class="row">
                <div class="col-lg-7 col-md-7 col-12">

                  <div class="single--row-info">
                    {{ __('forms.EvaluationChart.questions.questions_setting.question8.indicatorsLabel') }}
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="single--row-info">
                    <div class="single--row-info-group">
                      {{ __('forms.EvaluationChart.questions.questions_setting.question8.evaluations') }}
                    </div>
                    <div class="single--row-columns">
                      <div class="single--row-column" v-for="(column, indexC) in columns" :key="indexC">
                        {{ column }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-1 col-md-1 col-12">
                  <div class="single--row-info">
                    Note
                  </div>
                </div>
              </div>
            </div>

            <div class="single--row single--row-content" v-for="(indicator, j) in factor.indicators" :key="j">
              <div class="row">
                <div class="col-lg-7 col-md-7 col-12">
                  <div class="single--row-info p-2">
                    {{ indicator.name }}
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="single--row-info">
                    <div class="single--row-columns single--row-columns-full-height">
                      <div class="single--row-column text-wrap" v-for="(column, indexC) in columns" :key="indexC">
                        <input v-if="column_permission[indexC]['permission'] > 1" type="number" :data-factor="indexF"
                          :data-indicator="indicator.id" :data-column="indexC" :class="' input-width form-control pnpIndicator text-center ' +
                            column_permission[indexC]['classRequired']
                            " @blur="checkIndicatorRange" :name="'question[' +
                              question_survey_id +
                              '][' +
                              indexF +
                              '][' +
                              indicator.id +
                              '][' +
                              indexC +
                              ']'
                              " step="1" :value="indicatorValues[indicator.id][indexC]" :min="range_value['min']"
                          :max="range_value['max']" />
                        <label v-else> {{ values[indicator.id][indexC] }} </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-1 col-md-1 col-12">
                  <div class="single--row-info">
                    <button type="button" v-if="indicator.note !== ''" class="btn bg-transparent text-info"
                      @click="openNote(indicator.note)">
                      <i style="font-size: 15px" class="fas fa-info-circle"></i>
                    </button>
                    <button type="button" v-else class="btn bg-transparent text-info disabled">
                      <i style="font-size: 15px" class="fas fa-info-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<style>
.table--custom .single--row-head {
  background: #559bd9 important;
  ;
}
</style>

<script>
function ctrl_validation_cell(value_str, min, max, required) {
  if (value_str.length === 0 || value_str === "") {
    return true;
  }
  let value = parseInt(value_str);

  if (value === 0 && !required) {
    return true;
  }
  return !(isNaN(value) || value < min || value > max);
}

export default {
  created() {
    this.factorsTable = this.factors_zeros;
    this.summary = this.summary_zeros;
    this.indicatorValues = this.values;
  },
  mounted() {
    //settings UP col-md for bootstrap table
    this.colMdFact =
      "col-md-" + (12 - 2 * Object.keys(this.columns).length - 1); // 12 (max columnMd - 2*columns - 1 for weight)
    this.colMdPresAver = "col-md-" + 2 * Object.keys(this.columns).length;
    this.colMdGraphs =
      (this.graphs.radar && (!this.graphs.bars || this.show_weights)) ||
        (!this.graphs.radar && this.graphs.bars)
        ? 12
        : 6;
    this.onUpdateFactors();

    if (Object.keys(this.columns).length > 3) {
      $(".fontMin").css("font-size", "10px");
    }

  },

  props: {
    required_factor: {
      type: Array,
      required: true,
    },
    column_permission: {
      type: Object,
      required: true,
    },
    data_route_factors: {
      type: String,
      required: true,
    },
    values: {
      type: [Object, Array],
      required: true,
    },
    columns: {
      type: Object,
      required: true,
    },
    columns_color: {
      type: Object,
      required: true,
    },
    graphs: {
      type: Object,
      required: true,
    },
    show_weights: {
      type: Boolean,
      required: true,
    },
    show_arithmetic_mean: {
      type: Boolean,
      required: true,
    },
    show_arithmetic_weights_mean: {
      type: Boolean,
      required: true,
    },
    range_value: {
      type: Object,
      required: true,
    },
    factors_zeros: {
      type: Object,
      required: true,
    },
    summary_zeros: {
      type: Object,
      required: true,
    },
    factors_indicators: {
      type: [Object, Array],
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: false,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      test: 1,
      colMdFact: 7,
      colMdPresAver: 2,
      summary: [],
      factorsTable: [],
      colMdGraphs: "6",
      indicatorValues: {},
      //default
      activeTab: null,
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    toggle(index) {
      this.$refs[`collapse${index}`][0].classList.toggle("d-none");
      this.$refs[`chevron${index}`][0].classList.toggle("fa-rotate-180");
    },
    hideAll() {
      let refs = this.$refs;
      console.clear();

      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("collapse"),
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("fa-rotate-180");
      });
    },
    showAll() {
      let refs = this.$refs;
      console.clear();
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("collapse"),
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("fa-rotate-180");
      });
    },
    mountedDelayed() {
    },

    openNote(note) {
      Vue.swal.fire({
        title: "",
        html: note,
        width: 1000,
      });
    },
    //function check if number and if number is in range
    checkIndicatorRange(event) {
      let factor = parseInt(event.target.getAttribute("data-factor"));
      if (
        !ctrl_validation_cell(
          event.target.value,
          this.range_value.min,
          this.range_value.max,
          this.required_factor.includes(factor),
        )
      ) {
        event.target.value = null;
        Vue.$toast.open({
          message: "Incorrected value!",
          type: "warning",
          position: "top-left",
        });
        return false;
      }
      let readValueTxt = event.target.value;
      let readValue = Math.floor(parseInt(readValueTxt));

      this.indicatorValues[event.target.getAttribute("data-indicator")][
        event.target.getAttribute("data-column")
      ] = readValue;
    },

    drawRadarGraph() { },
    onUpdateFactors() {
      //calling ajax for build factorsTable

      axios
        .post(decodeURI(this.data_route_factors), {
          indicators: this.indicatorValues,
          columns: this.columns,
          question_survey_id: this.question_survey_id,
          columns_color: this.columns_color,
          max_indicator: this.range_value.max,
          empty_values: this.empty_values, //show empty values if set true,
          column_permission: this.column_permission,
        })
        .then((response) => {
          this.factorsTable = response.data.factors;
          this.summary = response.data.summary;
          this.horizontalGraphSettings = response.data.horizontalGraphSettings;

          if (this.graphs.radar && this.show_arithmetic_weights_mean && this.show_weights && !this.empty_values) {
            this.$refs.radar_pnp.drawRadarGraph(
              response.data.radarGraphSettings,
            );
          }
          if (this.graphs.bars && this.show_arithmetic_mean && !this.empty_values) {
            this.$refs.horizontal_bar_pnp.drawBarsGraph(
              response.data.horizontalGraphSettings,
            );
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
};
</script>

<style scope>
.bg-transparent {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
<style>
.chartjs-size-monitor {
  position: fixed !important;
}
</style>
